var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhPlusBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.08594C10.2486 3.08594 10.4871 3.18471 10.6629 3.36052C10.8387 3.53634 10.9375 3.7748 10.9375 4.02344L10.9375 9.96094L16.875 9.96094C17.1236 9.96094 17.3621 10.0597 17.5379 10.2355C17.7137 10.4113 17.8125 10.6498 17.8125 10.8984C17.8125 11.1471 17.7137 11.3855 17.5379 11.5613C17.3621 11.7372 17.1236 11.8359 16.875 11.8359L10.9375 11.8359L10.9375 17.7734C10.9375 18.0221 10.8387 18.2605 10.6629 18.4363C10.4871 18.6122 10.2486 18.7109 10 18.7109C9.75136 18.7109 9.5129 18.6122 9.33709 18.4363C9.16127 18.2605 9.0625 18.0221 9.0625 17.7734L9.0625 11.8359L3.125 11.8359C2.87636 11.8359 2.6379 11.7372 2.46209 11.5614C2.28627 11.3855 2.1875 11.1471 2.1875 10.8984C2.1875 10.6498 2.28627 10.4113 2.46209 10.2355C2.6379 10.0597 2.87636 9.96094 3.125 9.96094L9.0625 9.96094L9.0625 4.02344C9.0625 3.7748 9.16127 3.53634 9.33709 3.36052C9.5129 3.18471 9.75136 3.08594 10 3.08594Z",
    fill: "#00F981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhPlusBold);
export default __webpack_public_path__ + "static/media/ph_plus-bold.070ebdb34dbe0fe75336a23a441eabe4.svg";
export { ForwardRef as ReactComponent };